export class chemistModel
{
    _ID:number;
    employeeCode:number;
    CustomerName:string;
    cheType:string;
    Area:string;
    DA_type:string;
    ConcernPerson:string;
    Address:string;
    pincode:number;
    route_name:string;
    phone:number
    KM:number
    email:string
    Fax:number;
    mobile:number;
    // route_name: this.chemist_form.value.che_Type,
    visit_frequency:number;
    religion:string;
    category:string;
}

export class chemistmasterdata
{
    StateID: number;
    HQ: string;
    ClientID: number;
    Client_Code :string;
    DivisionID: number;
    Category: string
    Area: string;
    designation:string;
    currentMonth:string;
    status:string;
    ManagerID:string;
    LoginId:any;
}

export class chemistlisttransfermodel
{
    EmployeeCode:string;
    EmployeeCodeTo:string;
    RouteId:string;
    Area_Id:string;
    id:string;
}

export class stockistmaster
{
    EmployeeCode:string;
    ManagerID:string;
    
}


export class imei
{
   
    Employee_ID: string;
    
}

export class tourprogramlist
{
    StateID: number;
    Client_Code: string;
    fromDate: string;
    toDate: string;
    currentMonth:string;
    HQ:string;
    Approval:string;
}

export class pobDataModel
{
    fromDate: string;
    toDate: string;
    stateId: number
    hq: number
    employeeCode: string
    product_group: string
    product_code: string
    stafftype: string
    partyType:string
    ManagerID:string
    LoginId:any
}

export class NonlistedcallDataModal
{
    fromDate: string;
    toDate: string;
    employeeCode: string;
    Type:string;
    LoginId:any;
   
}
export class dcrunlockdataModel
{
    fromDate: string;
    toDate: string;
    stateId: number;
    ManagerID:string;
    empId:Number;
}
export class RouteDivertApprovaldataModel
{   
    ManagerID:string;
    userId:Number;
    empId:Number;
}
export class TPdeviationReportModel
{   
    ManagerID:number;
    userId:string;
    currentMonth:string;
    HQ:number;
    empId:Number;
}
export class livetrackingModel
{
    
    FromDate:Date=new Date();
    fromDate=this.FromDate.getFullYear()+'-'+(this.FromDate.getMonth()+1)+'-'+this.FromDate.getDate();
    ToDate:Date=new Date();
    toDate=this.ToDate.getFullYear()+'-'+(this.ToDate.getMonth()+1)+'-'+this.ToDate.getDate();
    employee:string;
    division:string;
    zone:string;
    state:string;
    staffType:string;
    employeeCode:number;
    workingType:string;
    flag:string='H';
    ManagerID:string;
    LoginId:any
}
export class EmpAttendanceModel
{
    fromDate: string;
    toDate: string;
    status:string;
    LoginId:any;
}

export class EmpMasterModel
{   
    ManagerID:number;
    stateId :number;
    HQ:number;
    status:number;
    empId:Number;
   
}
export class ExpenseEligiblityModel
{   
    employeeCode: string
    ManagerID:number;
    status:number;
    empId:Number;
   
}

export class DailyExpenseModel
{   
    fromDate: string;
    toDate: string;
    employeeCode: string
    ManagerID:number;
    status:number;
    empId:Number;
   
}
export class FirstLastCallDataModel
{
    fromDate: string;
    toDate: string;
    employeeCode: string;
    stafftype: string;
    ManagerID:string;
    LoginId:any
}

export class lateworkingModel
{
    fromDate: string;
    toDate: string;
    empId: number;
    LoginId:any;

}

